"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.object.values");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ModalSize = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactModal = _interopRequireDefault(require("react-modal"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ButtonGroup = _interopRequireDefault(require("../ButtonGroup"));

var _Button = _interopRequireDefault(require("../Button"));

var _Modal = _interopRequireDefault(require("./Modal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ModalSize = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};
exports.ModalSize = ModalSize;

var BasicModal = /*#__PURE__*/function (_React$Component) {
  _inherits(BasicModal, _React$Component);

  var _super = _createSuper(BasicModal);

  function BasicModal(props) {
    var _this;

    _classCallCheck(this, BasicModal);

    _this = _super.call(this, props);
    _this._scrollingEle = null;
    return _this;
  }

  _createClass(BasicModal, [{
    key: "scrollTo",
    value: function scrollTo() {
      var _this$_scrollingEle;

      (_this$_scrollingEle = this._scrollingEle).scrollTo.apply(_this$_scrollingEle, arguments);
    }
  }, {
    key: "scrollToElement",
    value: function scrollToElement() {
      var _this$_scrollingEle2;

      (_this$_scrollingEle2 = this._scrollingEle).scrollToElement.apply(_this$_scrollingEle2, arguments);
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _this$props = this.props,
          title = _this$props.title,
          children = _this$props.children,
          buttons = _this$props.buttons,
          onRequestClose = _this$props.onRequestClose,
          hideCloseBtn = _this$props.hideCloseBtn,
          size = _this$props.size,
          other = _objectWithoutProperties(_this$props, ["title", "children", "buttons", "onRequestClose", "hideCloseBtn", "size"]);

      var modalClasses = (0, _classnames.default)('basic-modal', (_classNames = {}, _defineProperty(_classNames, "basic-modal--".concat(size), !!size), _defineProperty(_classNames, 'basic-modal--no-close-btn', !!hideCloseBtn), _classNames));
      return /*#__PURE__*/_react.default.createElement(_Modal.default, _extends({
        className: modalClasses,
        overlayClassName: "basic-modal__overlay",
        onRequestClose: onRequestClose
      }, other), title && /*#__PURE__*/_react.default.createElement("div", {
        className: "basic-modal__header"
      }, /*#__PURE__*/_react.default.createElement("h2", {
        className: "h3"
      }, title)), /*#__PURE__*/_react.default.createElement("div", {
        className: "basic-modal__container scrolling",
        ref: function ref(_ref) {
          _this2._scrollingEle = _ref;
        }
      }, !hideCloseBtn && /*#__PURE__*/_react.default.createElement("div", {
        className: "basic-modal__header-closeBtn"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        onClick: onRequestClose,
        role: "button",
        iconOnly: true
      }, "Close")), /*#__PURE__*/_react.default.createElement("div", {
        className: "basic-modal__message"
      }, children)), buttons && buttons.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
        className: "basic-modal__buttons"
      }, /*#__PURE__*/_react.default.createElement(_ButtonGroup.default, null, buttons)));
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(el) {
      _reactModal.default.setAppElement(el);
    }
  }, {
    key: "Size",
    get: function get() {
      return ModalSize;
    }
  }]);

  return BasicModal;
}(_react.default.Component);

BasicModal.defaultProps = {
  title: null,
  children: null,
  buttons: [],
  onRequestClose: function onRequestClose() {},
  hideCloseBtn: false,
  size: ModalSize.SMALL,
  shouldCloseOnOverlayClick: false
};
BasicModal.propTypes = {
  onRequestClose: _propTypes.default.func,
  title: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  buttons: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  hideCloseBtn: _propTypes.default.bool,
  size: _propTypes.default.oneOf(Object.values(ModalSize)),
  shouldCloseOnOverlayClick: _propTypes.default.bool
};
var _default = BasicModal;
exports.default = _default;
//# sourceMappingURL=BasicModal.js.map